import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';

interface ContributionTableProps {
  title: string;
  value: string;
}

export const ContributionTable = ({ title, value }: ContributionTableProps) => {
  return (
    <div className="col-md-4 col-lg-6">
      <table
        className="table table-contribution-info"
        data-testid="contribution-table-details"
      >
        <thead>
          <tr>
            <th className="table-info-header body2">{title}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <h3 className="mt-1">
                {getPremiumStyled({
                  premium: String(value),
                  valueOnly: RETURN_VALUE_ONLY,
                })}
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
